import { Routes } from '@angular/router';

/**
 * 파트너 타입 마스터 라우트.
 *
 * @see projects/admin/docs/portal-layout-redesign/master-plan.md (Phase 1.5)
 * @see docs/portal-layout-redesign/spec/mockups/portal-branching-v4.html (STEP 2 + STEP 3)
 */
export const partnerTypeRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import(
        './components/smart/partner-type-master-page/partner-type-master-page.component'
      ).then((m) => m.PartnerTypeMasterPageComponent),
  },
];
